<template>
  <div class="count">
    <countComponent>
      <template v-slot:icon>
        <img src="@/assets/icon1.svg" alt="" />
      </template>
      <template v-slot:count> {{ schoolValue }} </template>
      <template v-slot:text> 院校总数 </template>
    </countComponent>
    <countComponent>
      <template v-slot:icon>
        <img src="@/assets/icon2.svg" alt="" />
      </template>
      <template v-slot:count> {{ sdeptValue }} </template>
      <template v-slot:text> 院系总数 </template>
    </countComponent>
    <countComponent>
      <template v-slot:icon>
        <img src="@/assets/icon3.svg" alt="" />
      </template>
      <template v-slot:count> {{ majorValue }} </template>
      <template v-slot:text> 专业总数 </template>
    </countComponent>
    <countComponent>
      <template v-slot:icon>
        <img src="@/assets/icon4.svg" alt="" />
      </template>
      <template v-slot:count> {{ classValue }} </template>
      <template v-slot:text> 班级总数 </template>
    </countComponent>
  </div>
</template>

<script>
import countComponent from "./count-component.vue";
import { getOrganDateView } from "@/api/comd.js";
export default {
  components: {
    countComponent,
  },
  data() {
    return {
      classValue: 0,
      majorValue: 0,
      schoolValue: 0,
      sdeptValue: 0,
    };
  },
  created() {
    this.getOrganDateViewHandel();

  },
  methods: {
    async getOrganDateViewHandel() {
      let res = await getOrganDateView();
      this.classValue = res.data.classValue;
      this.majorValue = res.data.majorValue;
      this.schoolValue = res.data.schoolValue;
      this.sdeptValue = res.data.sdeptValue;
    },
  },
};
</script>

<style scoped>
.count {
  width: 465px;
  height: 227px;
  display: flex;
  flex-flow: wrap;
  justify-content: space-around;
  align-items: center;
}
</style>